import { render, staticRenderFns } from "./Aggregates.vue?vue&type=template&id=46c86f47"
import script from "./Aggregates.vue?vue&type=script&lang=js"
export * from "./Aggregates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports